export const getSettingsTest = (testId) => ({ settingsTests }) =>
settingsTests.settingsTestsList.find(({ id }) => id === testId);